export const audienceTypes = ['owner', 'team-leader', 'qa-person'] as const;
